const helpSystemNodes = {
//  '--help-system-edit-page-pagetype-title': true,
//  '--help-system-edit-page-pagetype-pageheader': true,
//  '--help-system-edit-page-pagetype-pageheader-links': true,
//  '--help-system-edit-page-pagetype-seosettings-robots-tags-index': true,
//  '--help-system-edit-page-pagetype-seosettings-xmlsitemap-includeinxmlsitemap': true,
//  '--help-system-edit-page-pagetype-seosettings-xmlsitemap': true,
}

function stringMatch(str, pattern) {
  return str.toLowerCase().includes(pattern.toLowerCase())
}

export default {
  name: 'nav-tree-nodes',
  props: {
    searchString: {
      type: String,
      required: true
    },
    typeName: {
      type: String,
      required: true
    }
  },
  render(h) {
    const getVisibleNodes = (node) => {
      let children = null
      if (node.children && Object.values(node.children).length > 0) {
        children = Object.values(node.children).map(child => getVisibleNodes(child))
        children = children.filter((child) => child)
        if (stringMatch(node.label, this.searchString) || children.length > 0) {
          return { ...node, children }
        }
        return null
      }
      else {
        return (stringMatch(node.label, this.searchString)) ? node : null
      }
    }
    const renderNode = (node, depth, helpId) => {
      let children = null
      let newId = `${helpId}-${node.label.toLowerCase().replace(' ', '')}`
      if (node.children && node.children.length > 0) {
        children = node.children.map(child => renderNode(child, depth + 1, newId))
      }
      return h(
        (children) ? 'nav-tree-branch-node' : 'nav-tree-leaf-node',
        {
          props: {
            node,
            depth,
            helpSystemId: (helpSystemNodes[newId]) ? newId : ''
          }
        },
        children
      )
    }
    const visibleNodes = Object.values(this.$store.state.editPages.navTree).reduce((acc, node) => {
      const nodes = getVisibleNodes(node)
      if (nodes) acc.push(nodes)
      return acc
    }, [])
    return h(
      'div',
      visibleNodes.map(node => renderNode(node, 0, `--help-system-edit-page-${this.typeName}`))
    )
  }
}
